export default "__VITE_ASSET__C3yB4YFz__"